import type {StaticImageData} from 'next/image';
import type {ReactElement} from 'react';

import {typography} from '@/utilites/typography/typography';

import Card1Img from './assets/img1.webp';
import Card2Img from './assets/img2.webp';
import Card3Img from './assets/img3.webp';
import Card4Img from './assets/img4.webp';

export type ItemProps = {
	id: number;
	image: StaticImageData;
	title: string | ReactElement;
	desc: string | ReactElement;
};

export const data: ItemProps[] = [
	{
		id: 0,
		image: Card1Img,
		title: typography('Собирайте обратную связь'),
		desc: typography(
			'Проводите публичное и анонимное анкетирование сотрудников, меняйте последовательность и варианты ответов',
		),
	},
	{
		id: 1,
		image: Card2Img,
		title: typography('Настраивайте тип опроса'),
		desc: typography(
			'Предложите респондентам выбрать из списка готовых вариантов, ответить в свободной форме или указать значение на шкале в заданном диапазоне',
		),
	},
	{
		id: 2,
		image: Card3Img,
		title: typography('Выбирайте целевую аудиторию'),
		desc: typography(
			'Создавайте для сотрудников ссылки с общим доступом, отправляйте опросы всем участникам чата или канала',
		),
	},
	{
		id: 3,
		image: Card4Img,
		title: typography('Анализируйте данные'),
		desc: typography(
			'Просматривайте результаты массового анкетирования сотрудников внутри сервиса или выгружайте их в таблицы в формате xlsx',
		),
	},
];
